<script>
  import DefaultAvatar from '../../Common/DefaultAvatar.svelte';
  import { External } from '../../external';

  export let contact;

  const hasAvatar = !!contact.member?.extra?.avatar;
  const avatarStyle = hasAvatar
    ? `background-image:url('${External.getThumbnailsFromBase(contact.member.extra.avatar.base + '/', '640x480', true) + contact.member.extra.avatar.name}')`
    : '';
</script>

{#if hasAvatar}
  <div class="contact-image mb-10 relative flex align-center justify-center" style={avatarStyle}>
    <slot name="subscribed-fragment" />
  </div>
{:else}
  <DefaultAvatar wrapperClasses="contact-image mb-10 relative" identifier={contact.member?.id || contact.email} name={contact.name}>
    <slot name="subscribed-fragment" />
  </DefaultAvatar>
{/if}
